import { useAuth } from '@restworld/feature-authentication';
import { useRouter } from 'next/router';

export const useRedirectRoute = () => {
  const router = useRouter();
  const query = router?.['query'];
  const { isAuthenticated } = useAuth();
  const redirectUserCallback = () => {
    const historyState = window.history.state;
    if (query['id']) {
      // A spontaneous questionnaire is opened with the venue's id, so it returns to the venue page.
      router?.push(`/${query['isSpontaneousEntry'] === 'true' ? 'locale' : 'posizione'}/${query['id']}`);
      return;
    } else if (isAuthenticated) {
      router?.push(`/profilo${query['manage_using_klaaryo'] === 'true' ? `?manage_using_klaaryo=true}` : ''}`);
      return;
    } else {
      if (historyState?.idx > 0) router?.back();
      else router?.push('/cerco-lavoro');
      return;
    }
  };
  return {
    redirectUserCallback,
  };
};
